import React, { Component } from 'react';
import './style.css';

class App extends Component {
  render() {
    return (
        <div className="app">
           <nav>
              <a href="/" className="nav-logo">Armory</a>
              <ul className="nav-links">
                <li><a href="https://diablo09.com/play.html" target="_blank">Play</a></li>
                <li><a href="https://diablo09.com/about.html" target="_blank">About</a></li>
                <li><a href="https://diablo09.com/discord/" target="_blank">Discord</a></li>
                <li><a href="https://www.patreon.com/Diablo09/" target="_blank">Patreon</a></li>
              </ul>
           </nav>
           <div className="content-wrap">{this.props.children}</div>
           <footer>
             <div className="footer-logo">Armory</div>
             <ul className="footer-links">
               <li><a href="https://diablo09.com/play.html" target="_blank">Play</a></li>
               <li><a href="https://diablo09.com/about.html" target="_blank">About</a></li>
               <li><a href="https://diablo09.com/discord/" target="_blank">Discord</a></li>
               <li><a href="https://www.patreon.com/Diablo09/" target="_blank">Patreon</a></li>
             </ul>
             <p className="footer-copy">Diablo 09 is a private server and is not affiliated with Blizzard Entertainment.</p>
           </footer>
        </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/app/index.js